import StatusBadge from '@/components/base/StatusBadge';
import type { GossipEvent } from '@/types/gossip';

interface EventCardProps {
  event: GossipEvent;
}

function formatHeat(value: number) {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
}

export default function EventCard({ event }: EventCardProps) {
  return (
    <article className="group flex flex-col rounded-lg overflow-hidden border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
      <a href={`#${event.id}`} className="relative block w-full h-40 md:h-44 overflow-hidden cursor-pointer">
        <img
          src={event.cover}
          alt={`${event.title} 事件配图`}
          title={`${event.title} 瓜圈速报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 to-transparent"></div>
        <div className="absolute top-3 left-3">
          <StatusBadge status={event.status} />
        </div>
        <span className="absolute bottom-3 left-3 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-label text-foreground-800">
          #{event.category}
        </span>
      </a>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <a href={`#${event.id}`} className="cursor-pointer">
          <h3 className="font-heading text-base md:text-lg text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {event.title}
          </h3>
        </a>

        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{event.summary}</p>

        <div className="mt-3 rounded-md bg-accent-50 border border-accent-200/70 px-3 py-2">
          <p className="text-[11px] text-accent-700 font-label flex items-center gap-1">
            <i className="ri-flashlight-line"></i>
            {event.latestTime} · 最新
          </p>
          <p className="mt-0.5 text-xs text-foreground-700 line-clamp-1">{event.latestText}</p>
        </div>

        <div className="mt-4 pt-3 border-t border-background-200/70 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-refresh-line"></i>
            跟更 {event.updateCount} 次
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500"></i>
            {formatHeat(event.heat)}
          </span>
        </div>
      </div>
    </article>
  );
}